/**
 * Escuta os logs do servidor no navegador.
 *
 * Quando o cliente se conecta, o buffer acumulado no servidor é descarregado
 * de uma vez no console; depois disso, novos registros são buscados a cada
 * 15 segundos. Tudo aparece com o prefixo "[servidor]" no console do
 * navegador (erros em vermelho via console.error).
 */
import { obterLogsServidor, type EntradaLogServidor } from "@/lib/log-servidor.functions";
import { podeExecutarAutoDiagnostico, podeLogarAuth } from "@/lib/dev-config";
import devConfig from "@/../config/dev.config.json";

let iniciado = false;
let cursor = 0;

function exibir(entrada: EntradaLogServidor) {
  const texto = `[servidor] ${entrada.instante} [${entrada.nivel}] [${entrada.origem}] ${entrada.mensagem}`;
  const modoDev = (devConfig as { modoDev?: boolean })?.modoDev !== false;
  const mostrarLogConsole =
    (devConfig as { mostrarLogConsole?: boolean })?.mostrarLogConsole !== false;
  if (entrada.nivel === "erro") {
    if (entrada.detalhes) {
      if (modoDev) console.error(texto, entrada.detalhes);
    } else {
      if (modoDev) console.error(texto);
    }
  } else if (entrada.detalhes) {
    if (mostrarLogConsole) console.log(texto, entrada.detalhes);
  } else {
    if (mostrarLogConsole) console.log(texto);
  }
}

async function buscar() {
  try {
    const { logs, ultimoSeq } = await obterLogsServidor({ data: { depoisDe: cursor } });
    for (const entrada of logs) exibir(entrada);
    cursor = ultimoSeq;
  } catch {
    // Sem conexão (ou sessão ainda carregando): tenta de novo no próximo ciclo.
  }
}

/** Liga a escuta uma única vez por aba do navegador. */
export function iniciarEscutaLogsServidor() {
  if (iniciado || typeof window === "undefined") return;
  iniciado = true;
  void buscar();
  if (!devConfig?.suspenderFnFunctionsPeriodicas) {
    window.setInterval(
      () => void buscar(),
      podeLogarAuth() || podeExecutarAutoDiagnostico() ? 1000 : 15000,
    );
  } else {
    console.info("[logs-servidor] Polling suspenso por dev.config.suspenderFnFunctionsPeriodicas");
  }
}
